import React, { useContext, useEffect, useState } from "react";
import ProductsCard from "./card/ProductsCard";
import { httpReauest } from "../../utils/httpRequest";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "./Loading";
import { useSearchParams } from "react-router-dom";
import { FilterContext } from "../../context/FilterContext";
import { debounce } from "lodash";
const Products = ({ fit, four }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState();
  const [hasmore, sethasmore] = useState(false);
  const [loadmore, setloadmore] = useState(false);

  const filterData = useContext(FilterContext);

  const {
    filter_category,
    filter_year_start,
    filter_year_end,
    filter_min_price,
    filter_max_price,
    filter_min_tonaj,
    filter_max_tonaj,
    filter_haveImg,
    filter_onFire,
    filter_search_key,
    filter_brand,
    filter_lazing,
    filter_search_type,
    sort,
    setsort,
  } = filterData;

  useEffect(() => {
    if (fit) {
      newfetchData();
    }
  }, [fit]);

  useEffect(() => {
    // const debouncedFetchData = debounce(newfetchData, 300); // 300 میلی‌ثانیه تأخیر
    // debouncedFetchData();
    // return () => {
    //   debouncedFetchData.cancel(); // لغو تابع debounce در هنگام unmount
    // };
    newfetchData();
  }, [filterData]);

  async function newfetchData() {
    if (!loading) {
      setLoading(true);
      const page = 1;
      await httpReauest(
        "GET",
        "/vehicle?page=" +
          page +
          "&category=" +
          filter_category +
          "&year_start=" +
          filter_year_start +
          "&year_end=" +
          filter_year_end +
          "&min_price=" +
          filter_min_price +
          "&max_price=" +
          filter_max_price +
          "&min_tonaj=" +
          filter_min_tonaj +
          "&max_tonaj=" +
          filter_max_tonaj +
          "&haveImg=" +
          filter_haveImg +
          "&search_key=" +
          filter_search_key +
          "&search_type=" +
          filter_search_type +
          "&onFire=" +
          filter_onFire +
          "&brand=" +
          filter_brand +
          "&lazing=" +
          filter_lazing +
          "&sort=" +
          sort +
          "&fit=" +
          fit,
        {},
        {}
      ).then(({ data }) => {
        setProducts(data.data);
        setLoading(false);

        if (data?.data?.length == 16) {
          sethasmore(true);
        } else {
          sethasmore(false);
        }
      });
    }
  }

  async function fetchData() {
    const page = products.length / 16 + 1;
    await httpReauest(
      "GET",
      "/vehicle?page=" +
        page +
        "&category=" +
        filter_category +
        "&year_start=" +
        filter_year_start +
        "&year_end=" +
        filter_year_end +
        "&min_price=" +
        filter_min_price +
        "&max_price=" +
        filter_max_price +
        "&min_tonaj=" +
        filter_min_tonaj +
        "&max_tonaj=" +
        filter_max_tonaj +
        "&search_key=" +
        filter_search_key +
        "&search_type=" +
        filter_search_type +
        "&haveImg=" +
        filter_haveImg +
        "&onFire=" +
        filter_onFire +
        "&brand=" +
        filter_brand +
        "&lazing=" +
        filter_lazing +
        "&sort=" +
        sort +
        "&fit=" +
        fit,
      {},
      {}
    ).then(({ data }) => {
      setProducts((cur) => [...cur, ...data.data]);

      if (data?.data?.length < 16) {
        sethasmore(false);
      }
    });
  }

  return (
    <>
      <span className="relative ms-auto block mb-3">
        <select
          id="lazing"
          name="lazing"
          onChange={(e) => setsort(e.target.value)}
          className={` form-brand h-[35px] w-[280px]`}
        >
          <option value={"-createdAt"}> جدید ترین</option>
          <option value={"createdAt"}> قدیمی ترین</option>
          <option value={"price"}> ارزان ترین</option>
          <option value={"-price"}> گران ترین</option>
          <option value={"-year"}> سال ساخت از بیشترین</option>
          <option value={"year"}> سال ساخت از کمترین</option>
        </select>
        <p className="on-border">مرتب سازی</p>
      </span>
      <InfiniteScroll
        dataLength={products?.length ? products?.length : 16} //This is important field to render the next data
        next={fetchData}
        hasMore={hasmore && loadmore}
        loader={"Loading..."}
      >
        {loading ? (
          <Loading />
        ) : (
          <div
            className={`${
              four ? "grid grid-cols-4 gap-4" : "grid grid-cols-3 gap-4"
            }`}
          >
            {products?.map((e) => (
              <span>
                <ProductsCard data={e} />
              </span>
            ))}
            {!loadmore && (
              <div className="col-span-full flex justify-center">
                <button onClick={() => setloadmore(true)} className="btn-brand">
                  بارگزاری بیشتر
                </button>
              </div>
            )}
          </div>
        )}
      </InfiniteScroll>
    </>
  );
};

export default Products;
